import { render, staticRenderFns } from "./select-plan.vue?vue&type=template&id=65e27caa&scoped=true&"
import script from "./select-plan.vue?vue&type=script&lang=js&"
export * from "./select-plan.vue?vue&type=script&lang=js&"
import style0 from "./select-plan.vue?vue&type=style&index=0&id=65e27caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e27caa",
  null
  
)

export default component.exports